// Stripe Price IDs — public identifiers, safe for client-side.
// Backend validates these server-side against its own allowlist.
//
// During the Individual Pro → Premium (formerly Business) consolidation,
// BUSINESS_* now points to the new unified Premium Prices at $6/$60 on
// the renamed "Haven Premium" Stripe Product. The old Business Prices
// ($8/$84) have been archived in Stripe and will reject new subscriptions.
//
// PREMIUM_* still points at the old Individual Pro Prices — those remain
// active in Stripe so existing Individual Pro subs keep billing correctly
// until the migration runs. The Individual Pro UI is being removed, so
// nothing new will reference these. They can be archived post-migration.
export const STRIPE_PRICE_IDS = {
  PREMIUM_MONTHLY: process.env.REACT_APP_STRIPE_PREMIUM_MONTHLY_PRICE_ID || 'price_1SzqbjHiionGGcA0qCf2lhFp',
  PREMIUM_ANNUAL: process.env.REACT_APP_STRIPE_PREMIUM_ANNUAL_PRICE_ID || 'price_1SzqbjHiionGGcA0E5KoHEEM',
  BUSINESS_MONTHLY: process.env.REACT_APP_STRIPE_BUSINESS_MONTHLY_PRICE_ID || 'price_1TK8QaHiionGGcA0viXOQFUP',
  BUSINESS_ANNUAL: process.env.REACT_APP_STRIPE_BUSINESS_ANNUAL_PRICE_ID || 'price_1TK8QoHiionGGcA0yNo0e5GN',
};
